import { Outlet } from "react-router-dom"



export const InstructorLayout = () => {
    return <Outlet/>;
}